export const tooltipCopy = {
  org_distributionTargetDate:
    'The day you would like to start distributing your flyer. Please note, approvals can take up to a week to process.',
  sod_distributionTargetDate:
    'The day you would like to start distributing your flyer.',
  postExpirationDate:
    'The last day your flyer will be posted on the school’s web flyerboard. Your flyer can be posted up to 30 days from the last distribution. If you want your flyer posting to expire further out, you’ll need to add an additional distribution.',
};
